import { render, staticRenderFns } from "./UpdateNews.vue?vue&type=template&id=704d1793&scoped=true"
import script from "./UpdateNews.vue?vue&type=script&lang=js"
export * from "./UpdateNews.vue?vue&type=script&lang=js"
import style0 from "./UpdateNews.vue?vue&type=style&index=0&id=704d1793&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704d1793",
  null
  
)

export default component.exports